/**
 * Constants
 *
 * @description general constants
 */
export const Constants = {
  MOCK_FLAG: 'mockRequest',
  NEW_URL_COMPLAINT_BOOK: '/complaint-book',
  GENERAL_ERROR_ILUSTRATION: 'generalErrorDisabled1Medium',
  CLAIM_IMAGE:
    'https://pedidosya.dhmedia.io/image/pedidosya/order-management/complaint-book/claim.svg',
  COMPLAINT_IMAGE:
    'https://images.dhmedia.io/image/pedidosya/order-management/complaint-book/complaint.svg',
  SUCCESS_IMAGE:
    'https://images.dhmedia.io/image/pedidosya/order-management/complaint-book/success.svg',
};
